import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PrivateRoute from '../../common/components/router/PrivateRoute';
import { PERMISSIONS } from '../../common/constants';
import IdentityUsers from '../../features/Users/IdentityUsers';
import IdentityUserDetails from '../../features/Users/IdentityUserDetails';
import AddNewIdentityUser from '../../features/Users/AddNewIdentityUser';
import AddNewCustomer from '../../features/customers/AddNewCustomer';
import NotFound from '../../common/components/router/NotFound';

const UserAppRoutes = () => (
  <Routes>
    <Route
      path="/search"
      element={
        <PrivateRoute permissions={[PERMISSIONS.UserRead]}>
          <IdentityUsers />
        </PrivateRoute>
      }
    />
    <Route
      path="/details/:identityId"
      element={
        <PrivateRoute
          permissions={[PERMISSIONS.UserRead, PERMISSIONS.UserModify]}
        >
          <IdentityUserDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/addNew"
      element={
        <PrivateRoute
          permissions={[PERMISSIONS.UserRead, PERMISSIONS.UserModify]}
        >
          <AddNewIdentityUser />
        </PrivateRoute>
      }
    />
    <Route
      path="/addNewCustomer"
      element={
        <PrivateRoute
          permissions={[PERMISSIONS.UserRead, PERMISSIONS.UserModify]}
        >
          <AddNewCustomer />
        </PrivateRoute>
      }
    />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default UserAppRoutes;
